var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMildGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / Flavor / Mild Green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "MildG-path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9205458,29.1949658 L24.9205458,29.6197724 L32,29.6197724 L32,29.1949658 C31.1153145,29.1240333 31.0089158,28.8765578 31.0089158,28.5577558 L31.0089158,12.0620166 C31.0089158,11.7436087 31.1153145,11.4957391 32,11.4248067 L32,11 L22.4071721,11 L22.4071721,11.4248067 C22.9734496,11.4602729 23.2567854,11.63721 23.2567854,12.0620166 C23.2567854,12.5222895 21.3451554,16.1682183 19.7168612,19.6726762 C19.362987,18.7170583 16.3893404,12.3098862 16.3893404,12.0620166 C16.3893404,11.63721 16.6726762,11.4602729 17.2389537,11.4248067 L17.2389537,11 L8,11 L8,11.4248067 C8.88507955,11.4957391 8.99108418,11.7436087 8.99108418,12.0620166 L8.99108418,28.5577558 C8.99108418,28.8765578 8.88507955,29.1240333 8,29.1949658 L8,29.6197724 L14.230235,29.6197724 L14.230235,29.1949658 C13.3451554,29.1240333 13.2387567,28.8765578 13.2387567,28.5577558 L13.2387567,15.3189991 L13.3096892,15.3189991 L19.5399241,29.1949658 L25.8406975,15.4600759 L25.91163,15.5310083 L25.91163,28.5577558 C25.91163,28.8765578 25.8056253,29.1240333 24.9205458,29.1949658",
    id: "MildG-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MildG-icon-/-Flavor-/-Mild-Green",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "MildG-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "MildG-New"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "MildG-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "MildG-\\u2747\\uFE0F--Shape-/-Circle-/-Color_Solid"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "MildG-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MildG-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "MildG-Oval",
    fill: "#006938",
    fillRule: "evenodd",
    xlinkHref: "#MildG-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MildG-\\uD83C\\uDFA8--Color-/-Primary-/-Green-/-100%",
    mask: "url(#MildG-mask-2)",
    fill: "#006938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "MildG-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MildG-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "MildG-Fill-1",
    fill: "#231F20",
    xlinkHref: "#MildG-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MildG-\\uD83C\\uDFA8--Color-/-Secondary-/-White-/-100%",
    mask: "url(#MildG-mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMildGreen);
export default __webpack_public_path__ + "static/media/MildGreen.2c5dba4260f1adef35ecba2072fb73a8.svg";
export { ForwardRef as ReactComponent };